import {ChangeDetectionStrategy, Component, model} from '@angular/core';

@Component({
    selector: 'app-table-search',
    templateUrl: './table-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {style: 'display: contents'}
})
export class TableSearchComponent {
    /** :param value: the search text. */
    readonly value = model('');
}
